webpackJsonp([4940080089485],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/GenericPost/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _section, _section2;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GenericPost = function (_React$Component) {
	  _inherits(GenericPost, _React$Component);
	
	  function GenericPost() {
	    _classCallCheck(this, GenericPost);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  GenericPost.prototype.render = function render() {
	
	    var post = this.props.data.prismicDocument;
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_reactHelmet.Helmet, { title: _prismicDom2.default.RichText.asText(post.data.title) }),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'h1',
	          null,
	          _prismicDom2.default.RichText.asText(post.data.title)
	        )
	      ),
	      Glamor.createElement('div', { css: styles.section2, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(post.data.page_content) } })
	    );
	  };
	
	  return GenericPost;
	}(_react2.default.Component);
	
	exports.default = GenericPost;
	;
	
	var styles = {
	  section1: (_section = {
	    background: '#F4F8FC'
	  }, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    padding: '70px 50px'
	  }, _section),
	  section2: (_section2 = {}, _section2[_presets2.default.Desktop] = {
	    padding: '100px',
	    '& p, & li': {
	      fontSize: '18px',
	      lineHeight: '35px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2[_presets2.default.Tablet] = {
	    padding: '0 50px',
	    '& p, & li': {
	      fontSize: '18px',
	      lineHeight: '35px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2[_presets2.default.Mobile] = {
	    padding: '0 20px',
	    marginBottom: '60px',
	    '& p, & li': {
	      marginLeft: '50px',
	      marginRight: '50px',
	      lineHeight: '30px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2)
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-generic-post-index-js-accfdb1664b05aa336e9.js